import { render, staticRenderFns } from "./FlexiquoteModuleListSideMenu.vue?vue&type=template&id=59f62922"
import script from "./FlexiquoteModuleListSideMenu.vue?vue&type=script&lang=js"
export * from "./FlexiquoteModuleListSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59f62922')) {
      api.createRecord('59f62922', component.options)
    } else {
      api.reload('59f62922', component.options)
    }
    module.hot.accept("./FlexiquoteModuleListSideMenu.vue?vue&type=template&id=59f62922", function () {
      api.rerender('59f62922', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/superadmin/flexiquotemodule/FlexiquoteModuleListSideMenu.vue"
export default component.exports